/**
 * The words of a form's `lines` field (lines.ts, docs/ui-components.md §6), and of the typed fields
 * it draws (a day's order): shared by every unit, so they live in the core's catalogue. A column's
 * own words are the unit's.
 */
export const LINES_EN = {
    'lines.add': 'Add a line',
    'lines.remove': 'Remove the line',
    'lines.empty': 'No lines yet',
    'lines.total': 'Total',
    'lines.min': 'Add at least {n} line(s)',
    'lines.max': 'At most {n} lines',
    'lines.cells': 'Correct the marked cells',
    'lines.removed': 'Line {n} removed',
    'lines.cell': '{column} — line {n}',
    'lines.pasted': '{lines} line(s) filled from the pasted cells',
    'lines.pasted.unread': '{lines} line(s) filled; {unread} cell(s) could not be read and were left empty',
    // A day typed in figures: the order the field reads it in, said in its placeholder and its hint.
    'date.order.dmy': 'dd/mm/yyyy',
    'date.order.mdy': 'mm/dd/yyyy',
    'date.order.ymd': 'yyyy/mm/dd',
    'date.order.hint': 'Type the day as {order}',
};
export const LINES_AR = {
    'lines.add': 'إضافة بند',
    'lines.remove': 'حذف البند',
    'lines.empty': 'لا بنود بعد',
    'lines.total': 'الإجمالي',
    'lines.min': 'أضف {n} بند على الأقل',
    'lines.max': '{n} بند على الأكثر',
    'lines.cells': 'صحّح الخلايا المعلَّمة',
    'lines.removed': 'حُذف البند {n}',
    'lines.cell': '{column} — البند {n}',
    'lines.pasted': 'مُلئ {lines} بند من الخلايا الملصقة',
    'lines.pasted.unread': 'مُلئ {lines} بند، وتُركت {unread} خلية فارغة لأنها لم تُقرأ',
    'date.order.dmy': 'يوم/شهر/سنة',
    'date.order.mdy': 'شهر/يوم/سنة',
    'date.order.ymd': 'سنة/شهر/يوم',
    'date.order.hint': 'اكتب التاريخ بترتيب {order}',
};
//# sourceMappingURL=i18n-lines.js.map